import { useEffect, useRef } from 'react'
import supportChatService, { type SupportChatEvent } from '@/services/supportChatService'

/**
 * Subscribe to support chat SSE; falls back quietly when the stream errors
 * (caller should keep a polling interval as secondary).
 */
export function useSupportChatEvents(opts: {
  shopId?: number | null
  threadId?: number | null
  enabled?: boolean
  onEvent: (event: SupportChatEvent) => void
}) {
  const onEventRef = useRef(opts.onEvent)
  onEventRef.current = opts.onEvent

  useEffect(() => {
    if (opts.enabled === false) return
    if (!opts.shopId && !opts.threadId) return

    const close = supportChatService.openEventStream({
      shopId: opts.shopId ?? undefined,
      threadId: opts.threadId ?? undefined,
      onEvent: (event) => onEventRef.current(event),
    })
    return close
  }, [opts.shopId, opts.threadId, opts.enabled])
}
